<template>
  <div class="ems-layout">
    <!-- 顶部导航 -->
    <div class="ems-header">
      <div class="ems-nav">
        <div
          v-for="item in navList"
          :key="item.name"
          :class="['nav-item', { active: isActive(item) }]"
          @click="handleNavClick(item)">
          <span class="nav-name">{{ item.name }}</span>
          <!-- 下拉菜单 -->
          <div v-if="item.children && item.children.length" class="nav-dropdown">
            <div
              v-for="sub in item.children"
              :key="sub.path"
              :class="['dropdown-item', { active: $route.path === sub.path }]"
              @click.stop="handleSubClick(sub)">
              {{ sub.name }}
            </div>
          </div>
        </div>
      </div>

      <!-- 右侧操作区 -->
      <div class="ems-actions">
        <!-- 站点选择 -->
        <div class="action-item station-select">
          <el-select
            :value="selectedStation"
            size="mini"
            popper-class="ems-station-dropdown"
            @change="onStationChange">
            <el-option
              v-for="st in stationList"
              :key="st.code"
              :label="st.name"
              :value="st.code"></el-option>
          </el-select>
        </div>
      </div>
    </div>

    <!-- 内容区 -->
    <div class="ems-main">
      <slot />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'EmsLayout',
    computed: {
      selectedStation() {
        return this.$store.getters.emsStationCode;
      },
    },
    data() {
      return {
        stationList: [
          { code: '11010100001', name: '11010100001' },
          { code: '11010100002', name: '11010100002' },
        ],
        navList: [
          { name: 'EMS监控', path: '/energyStorage/home' },
          {
            name: '基站监控',
            children: [
              { name: 'BMS监控', path: '/energyStorage/bmsMonitor' },
              { name: 'PCS监控', path: '/energyStorage/pcsMonitor' },
            ],
          },
          {
            name: '分析',
            children: [{ name: '储能收益分析报表', path: '/energyStorage/incomeAnalysis' }],
          },
        ],
      };
    },
    methods: {
      onStationChange(code) {
        this.$store.commit('setEmsStationCode', code);
      },
      isActive(item) {
        if (item.path) return this.$route.path === item.path;
        if (item.children) {
          return item.children.some(c => this.$route.path === c.path);
        }
        return false;
      },
      handleNavClick(item) {
        if (item.path) {
          this.$router.push(item.path);
        }
      },
      handleSubClick(sub) {
        this.$router.push(sub.path);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '../styles/variables.scss';

  .ems-layout {
    height: 100%;
    display: flex;
    flex-direction: column;
    background: $bg-primary;
    overflow: hidden;
  }

  .ems-header {
    height: 54px;
    min-height: 54px;
    background: #fff;
    border-bottom: 1px solid $bg-card-border;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    position: relative;
    z-index: 100;
  }

  .ems-nav {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .nav-item {
    position: relative;
    padding: 0 18px;
    height: 54px;
    display: flex;
    align-items: center;
    cursor: pointer;
    color: $text-secondary;
    font-size: 14px;
    transition: all 0.3s;

    &:hover,
    &.active {
      color: $accent-blue;
      background: rgba(77, 140, 253, 0.08);
    }

    &.active {
      border-bottom: 2px solid $accent-blue;
    }
  }

  .nav-dropdown {
    position: absolute;
    top: 54px;
    left: 0;
    min-width: 140px;
    background: #fff;
    border: 1px solid $bg-card-border;
    border-radius: 0 0 4px 4px;
    padding: 6px 0;
    display: none;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  .nav-item:hover .nav-dropdown {
    display: block;
  }

  .dropdown-item {
    padding: 10px 18px;
    color: $text-secondary;
    font-size: 13px;
    cursor: pointer;
    transition: all 0.2s;
    white-space: nowrap;

    &:hover,
    &.active {
      color: $accent-blue;
      background: rgba(77, 140, 253, 0.08);
    }
  }

  .ems-actions {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  .action-item {
    color: $text-secondary;
    font-size: 13px;
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .ems-main {
    flex: 1;
    overflow: hidden;
    position: relative;
  }
</style>

<style lang="scss">
  @import '../styles/variables.scss';

  .ems-station-dropdown {
    background: #fff !important;
    border: 1px solid $bg-card-border !important;

    .el-select-dropdown__item {
      color: $text-secondary;

      &:hover,
      &.selected {
        background: rgba(77, 140, 253, 0.08) !important;
        color: $accent-blue !important;
      }
    }

    .popper__arrow {
      border-bottom-color: $bg-card-border !important;

      &::after {
        border-bottom-color: #fff !important;
      }
    }
  }

  .ems-header .station-select .el-input__inner {
    background: transparent;
    border: 1px solid $bg-card-border;
    color: $text-secondary;
    font-size: 13px;
    height: 28px;
    line-height: 28px;
    border-radius: 4px;
  }

  .ems-header .station-select .el-input__inner:focus {
    border-color: $accent-blue;
  }

  .ems-header .station-select .el-input__suffix .el-input__icon {
    line-height: 28px;
    color: $text-secondary;
  }
</style>
